import { useMatches } from "react-router";

import { isFullPageArchive } from "~/feature/pages/utils/isFullPageArchive";

export const useIsFullPageArchive = (): boolean =>
  isFullPageArchive(useMatches());
